import api from 'api'

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    getEmailNotificationDetails: build.query({
      query: ({ emailNotificationId }) => ({
        url: `/api/v1/email-notification/${emailNotificationId}`,
        method: 'GET',
      }),
    }),
  }),
})

export const { useLazyGetEmailNotificationDetailsQuery } = extendedApi
